import { useState } from "react";

import { getModalStyle } from '@/utils/Modal';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

//import IconButton from '@mui/material/IconButton';
//import CloseIcon from '@mui/icons-material/Close';
import {
    Check as YesIcon,
    Close as NoIcon
} from '@mui/icons-material';
//import Button from '@/components/Button';

import Dropdown from '@/components/Dropdown';

export default function TicketModal({t, open, setOpen, opening, isOwner, title, text, statuses, handleAnswer, fullScreen}){

	const { sxDialogMinHeight/*, sxCloseIcon*/ } = getModalStyle();

    const handleClose = () => {
        setOpen(false);
    }

    const [ status, setStatus ] = useState(statuses && statuses?.length > 0 ? statuses.filter((stat)=> (opening && stat.name === 'needs_action') || (!opening && stat.name === 'solved'))?.pop()?.id : null);

    const onChange = (newItem) => {
        setStatus(newItem);
    }

    return (
        
        <Dialog
            container={fullScreen?.active ? fullScreen?.node?.current : null}
            sx={sxDialogMinHeight}
            onClose={handleClose}
            open={open}
            fullWidth={true}
            maxWidth='sm'
        >
        	<DialogTitle className='modal-title'>
                {title}
            </DialogTitle>
            {/*
            <IconButton                    
                onClick={handleClose}
                sx={sxCloseIcon}
            >
                <CloseIcon/>
            </IconButton> 
            */}
            <DialogContent className='modal-content'>
                <div className='text-center'>
                    {text}
                </div>
                {
                    (!opening || !isOwner) && 
                    <>
                    <div className='mt-4 text-center'>
                        {
                            isOwner ? 
                                t('tickets.update.status_customer')
                            : 
                                t('tickets.update.status')
                        }
                    </div>
                    <div className='mt-2'>   
                        <Dropdown        
                            t={t}
                            translate='tickets.ticket_status_id'            
                            type='single'
                            name='ticket_status'
                            value={status}
                            options={statuses}
                            handleDropdown={onChange}
                            noempty
                            //error={}
                        />
                    </div>
                    </>
                }
            </DialogContent>
            <div className="modal-buttons">
                <div className='me-1'>
                    <YesIcon className='action-button-modal text-green-800' onClick={(e) => handleAnswer(e,true,status)}/>
                </div>
                <div className=''>
                    <NoIcon className='action-button-modal text-red-600' onClick={(e) => handleAnswer(e,false,status)}/>
                </div>
            </div>
        </Dialog>
  );
}